/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { LayerFarmListTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const layerFarmListResetTimestamp = (
  state,
  { procType, currentPage, sorts, filters, pageSize }
) => ({
  ...state,
  procType: procType || state.procType,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  // toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  // toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const layerFarmListFetchListLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const layerFarmListFetchListSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const layerFarmListAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const layerFarmListRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const layerFarmListSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [LayerFarmListTypes.LAYER_FARM_LIST_RESET_TIMESTAMP]: layerFarmListResetTimestamp,
  [LayerFarmListTypes.LAYER_FARM_LIST_FETCH_LIST_LOADING]: layerFarmListFetchListLoading,
  [LayerFarmListTypes.LAYER_FARM_LIST_FETCH_LIST_SUCCESS]: layerFarmListFetchListSuccess,
  [LayerFarmListTypes.LAYER_FARM_LIST_ADD_SELECTED_DOCUMENTS]: layerFarmListAddSelectedDocuments,
  [LayerFarmListTypes.LAYER_FARM_LIST_REMOVE_SELECTED_DOCUMENTS]: layerFarmListRemoveSelectedDocuments,
  [LayerFarmListTypes.LAYER_FARM_LIST_SET_WORKSPACE_VISIBLE]: layerFarmListSetWorkspaceVisible
});
